




















































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import uploaderFile from "./uploader.js";
const tagManager = namespace("tagManager");
@Component({})
export default class HelloWorld extends Vue {
  dialogVisible: boolean = false;
  chooseStroeType: number = 1;
  fileName: string | null = null;
  filePath: string | null = null;
  upLoadFile: any = null;
  loading: boolean = false;
  @tagManager.Action k1ImportTagStoreInfo;
  mounted() {
    this.upLoadFile = new uploaderFile({
      onSelectCallBack: file => {
        this.fileName = file.name;
      },
      onUploadSuccess: data => {
        this.filePath = data;
      }
    });
  }
  handleSelect() {
    this.upLoadFile.click();
  }

  async handleConfirm() {
    if (!this.filePath) {
      this.$message.warning("请选一个文件");
      return;
    }
    this.loading = true;
    await this.k1ImportTagStoreInfo({ url: this.filePath })
      .then(
        ({
          data: {
            k1ImportTagStoreInfo: { storeInfoDomainList }
          }
        }) => {
          this.$emit("on-select", storeInfoDomainList);
          this.handleRemove();
          this.dialogVisible = false;
        }
      )
      .finally(_ => {
        this.loading = false;
      });
  }

  handleRemove() {
    this.fileName = "";
    this.filePath = "";
    this.upLoadFile.remove();
  }
  beforeClose(done) {
    this.loading = false;
    this.handleRemove();
    done();
  }
  handleClose() {
    this.handleRemove();
    this.loading = false;
    this.dialogVisible = false;
  }
}
